import CategoriesTable from './ApartmentsTable'

export default CategoriesTable



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/DobovoTab/MappingTabs/ApartmentsTab/ApartmentsTable/index.js